/**
 * @module components/UserGuide
 * @description User guide link component for authenticated users.
 * Provides download link to PDF documentation, visible only when logged in.
 */

import React from 'react';
import { useIdentity } from '../providers/IdentityProvider';

import userGuide from '../assets/A24 International Servicing Site User Guide_7.13.2022.pdf';

/**
 * @typedef UserGuideProps
 * @property {string} [className] - Optional CSS className
 * @property {React.ReactNode} [children] - Children nodes (unused)
 */

/**
 * @component UserGuide
 * @type {React.FC<UserGuideProps>}
 * @summary Download link to user guide PDF for authenticated users.
 * Conditionally renders based on login status.
 * @param {UserGuideProps} props - Component props
 * @returns {React.ReactElement|null} Download link or null if not logged in
 */
function UserGuide({ className }) {
  const { isLoggedIn } = useIdentity();

  return isLoggedIn ? (
    <a className={className} href={userGuide} download>
      User Guide
    </a>
  ) : (
    <></>
  );
}

export default UserGuide;
